import ProjectDashboard from "./ProjectDashboard";
export default ProjectDashboard;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/areas/projects/components/ProjectDashboard/index.tsx